import styled from 'styled-components';

export const Wrapper = styled.div`
  position: absolute;
  bottom: 30px;
  right: var(--right-panel-px);
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 10px;
  background-color: var(--panels-bk-color-2);
  z-index: 9;

  @media (max-width: 768px) {
    display: none;
  }
`;
